import React from 'react';
import type { SVGProps } from 'react';

const SvgLinkedin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    {...props}
  >
    <path
      fill={props?.fill || 'rgb(172, 185, 201)'}
      d="M18 1.324V16.676c0 .351-.14.688-.388.936a1.32 1.32 0 0 1-.936.388H1.324a1.32 1.32 0 0 1-.936-.388A1.32 1.32 0 0 1 0 16.676V1.324C0 .972.14.636.388.388A1.32 1.32 0 0 1 1.324 0h14.352c.351 0 .688.14.936.388.248.248.388.584.388.936ZM5.294 6.882H2.647v8.47h2.647v-8.47Zm.238-2.912a1.5 1.5 0 0 0-.112-.584 1.5 1.5 0 0 0-.327-.501 1.5 1.5 0 0 0-.492-.356 1.5 1.5 0 0 0-.583-.094h-.047a1.53 1.53 0 0 0-1.086.45 1.53 1.53 0 0 0-.45 1.085c0 .407.162.798.45 1.086.288.288.679.45 1.086.45a1.5 1.5 0 0 0 1.09-.102 1.5 1.5 0 0 0 .471-.42c.13-.175.22-.375.264-.587a1.5 1.5 0 0 0 .024-.475v-.048l-.288.096Zm9.821 6.237c0-2.547-1.62-3.537-3.23-3.537a3.7 3.7 0 0 0-1.521.326 3.2 3.2 0 0 0-1.158.958h-.073V6.882H6.882v8.47h2.647v-4.505a1.54 1.54 0 0 1 .404-1.274 1.56 1.56 0 0 1 1.185-.621h.1c.842 0 1.467.53 1.467 1.864v4.536h2.647l.021-5.145Z"
    />
  </svg>
);

export default SvgLinkedin;
